<template>
  <div class="container">
    <div class="leftListOne">
            <div class="leftListOne_top">
              <span class="leftListOne_top_text">承灾体信息  </span>
            </div>
            <div class="cztxxtwo" id="cztxxtwoEch"></div>
    </div>
    <div class="leftListOne">
      <div class="leftListOne_top">
          <span class="leftListOne_top_text">减灾能力分析</span>
      </div>
      <div class="leftListTwo">
        <div class="cztxxtwo" id="jznlfxEch"></div>
      </div>
    </div>
    <div class="leftListOne">
      <div class="leftListOne_top">
          <span class="leftListOne_top_text">风险区域</span>
      </div>
          <!-- 饼图 -->
      <div class="leftListTwo">
        <div class="cztxxtwo" id="fxqyEch"></div>
      </div>
    </div>
  </div>
</template>
 
<script>
import "echarts-gl";
import * as echarts from "echarts";
import { queryIndexData } from '@/api';

export default {
  name: 'MyComponent',
  data () {
    return {
      IndexDataList:'',
    }
  },
  created(){
    
  },
   mounted() {
    this.$nextTick(() => {
      this.queryIndexDataApi();
      
    });
   },
  methods:{
    queryIndexDataApi(){
      queryIndexData().then(res=>{
        this.IndexDataList = res.data
        this.cztxxtwoJiek();
        this.jznlfxJiek();
        this.fxqyEJiek();
      })
    },
    cztxxtwoJiek() {
      let myLiuqiud = this.$echarts.init(document.getElementById("cztxxtwoEch"));
      var chartdata = [
          { name: '房屋(座) ', sum: this.IndexDataList.carrierHouse,size:65 },
          { name: '人口(万) ',sum: this.IndexDataList.carrierMen,size:65 },
          { name: '三次产业(项)', sum: this.IndexDataList.carrierThird,size:90 },
          { name: '基础设施(项)',sum: this.IndexDataList.carrierBase,size:80 },
          { name: '资源与环境(项)', sum: this.IndexDataList.carrierEnv,size:90 },
          { name: '公共服务设施(项)', sum: this.IndexDataList.carrierPublic,size:110 }
      ];
      var color = ['#43d8f9', '#28e9fa', '#1e8aff','#ab9bf6', '#ff6275', '#1ec8ea'];
      var data=[]

      chartdata.map((item,index)=>{
          data.push(
                {
              name:item.name+'\n\n'+item.sum,
              value: 111,
              symbolSize: item.size,
              draggable: true,
              label: {
                  normal: {
                      textStyle: {
                          fontSize: 12,
                          color: '#fff',
                      },
                  },
              },
              itemStyle: {
                  normal: {
                      color: new echarts.graphic.RadialGradient(0.5, 0.5, 1, [
                          {
                              offset: 0.2,
                              color: 'rgba(27, 54, 72, 0.2)',
                          },
                          {
                              offset: 0.8,
                              color: color[index],
                          },
                      ]),
                      opacity: 1,
                      borderWidth: 1,
                      borderColor: color[index],
                      shadowBlur: 7,
                      symbolOffset: 0.6,
                      shadowColor:color[index],
                  },
              },
          },
              )
      })

      let option = {
          animationDurationUpdate: function (idx) {
              return idx * 100;
          },
          tooltip: {
              trigger: 'item',
              formatter: function (params, ticket, callback) {
                  return params.data.tips || params.name;
              },
          },
          animationEasingUpdate: 'bounceIn',
          itemStyle: {
              // color: 'red',
          },
          cursor: 'pointer',
          series: [
              {
                  type: 'graph',
                  layout: 'force',
                  cursor: 'pointer',
                  force: {
                      repulsion: 200,
                      edgeLength: 100,
                  },
                  roam: true,
                  label: {
                      normal: {
                          show: true,
                      },
                  },

                  data,
              },
          ],
      };

      myLiuqiud.setOption(option);
    },
    jznlfxJiek() {
      let myChart = this.$echarts.init(document.getElementById("jznlfxEch"));
      var trafficWay = [{
          name: '政府',
          value: this.IndexDataList.analysisSoc
      },{
          name: '基层',
          value: this.IndexDataList.analysisBase
      },{
          name: '社会',
          value: this.IndexDataList.analysisSoc
      }];
      var value=10;
      var data = [];
      var color=['#006ced','#ffe000','#ffa800','#ff5b00','#ff3000']
      for (var i = 0; i < trafficWay.length; i++) {
          data.push({
              value: trafficWay[i].value,
              name: trafficWay[i].name,
              itemStyle: {
                  normal: {
                      borderWidth: 5,
                      shadowBlur: 20,
                      borderColor:color[i],
                      shadowColor: color[i]
                  }
              }
          }, {
              value: 2,
              name: '',
              itemStyle: {
                  normal: {
                      label: {
                          show: false
                      },
                      labelLine: {
                          show: false
                      },
                      color: 'rgba(0, 0, 0, 0)',
                      borderColor: 'rgba(0, 0, 0, 0)',
                      borderWidth: 0
                  }
      }
          });
      }
      var seriesOption = [{
          name: '',
          type: 'pie',
          clockWise: false,
          left: "-15%",
          radius: [105, 109],
          hoverAnimation: true,
          itemStyle: {
              normal: {
                  label: {
                      show: false
                  },
                  labelLine: {
                      show: false,
                  }
              }
          },
          data: data
      },
       {
             type: 'pie',
             radius: ['54%', '54.3%'],
             left: "-15%",
             hoverAnimation: false,
             clockWise: false,
             itemStyle: {
                 normal: {
                     color: '#00cfff',
                 }
             },
             label: {
                 show: false
             },
             data: _dashed()
         }];
      let option = {
          color : color,
          title: {
              // text: '{a|' + value + '}\n{c|交通方式}',
               text: '减灾能力',
              top: '48%',
              textAlign: "center",
              left: "42%",
              textStyle: {
                  color: '#fff',
                  fontSize: 22,
                  fontWeight: '400',
                    rich: {
                      a: {
                          fontSize: 30,
                          color: '#006ced',
                          fontWeight:'600',
                      },
                      c: {
                          fontSize:14,
                          color: '#ffffff',
                          padding: [5, 0]
                      }
                  }
              },
      

          },
          tooltip: {
              show: true
          },
          legend: {
              orient: 'vertical',
              data: ['政府','基层','社会'],
              itemWidth: 20,
              itemHeight: 20,
              top: '40%',
              left: '70%',
              itemGap: 20,
              textStyle: {
                  color: "#ffffff"
              },
              itemGap: 20,
              textStyle: {
                  fontSize: 15,
                  lineHeight: 24,
                  rich: {
                      text: {
                          fontSize: 15,
                            color: "#ffffff"
                      },
                      number: {
                          fontSize: 17,
                          color: "#1890FF",
                          fontWeight: 'bold'
                      },
                      unit: {
                          fontSize: 13,
                            color: "#ffffff"
                      },
                  }
              },
              formatter(name) {
                  const newData = trafficWay;
                  let tarValue = 0;
                  for (let i = 0; i < newData.length; i++) {
                      if (newData[i].name === name) {
                          tarValue = newData[i].value;
                      }
                  }
                  return `{text|${name}} {number|${tarValue}} {unit|%}`;
              },
          },
          toolbox: {
              show: false
          },
          series: seriesOption
      }

       function _dashed() {
            let dataArr = [];
            for (var i = 0; i < 10; i++) {
                if (i % 2 === 0) {
                    dataArr.push({
                        name: (i + 1).toString(),
                        value: 10,
                        itemStyle: {
                            normal: {
                                color: 'rgb(0,0,0,0)',
                            }
                        }
                    })
                } else {
                    dataArr.push({
                        name: (i + 1).toString(),
                        value: 20,
                        itemStyle: {
                            normal: {
                                color: 'rgb(0,0,0,0)',
                                borderWidth: 2,
                                borderColor: "rgba(255,215,0,1)"
                            }
                        }
                    })
                }

            }
            return dataArr
        }

        function doing() {
            let option1 = myChart.getOption();
            option1.series[1].startAngle = option1.series[1].startAngle - 1;
            myChart.setOption(option1);
        }

        function startTimer() {
            let timer = setInterval(doing, 100);
        }
        setTimeout(startTimer, 0);
      myChart.setOption(option);
    },
    fxqyEJiek() {
      let myChart = this.$echarts.init(document.getElementById("fxqyEch"));
      let trafficWay = [
        {
          name: '高风险区域',
          value: this.IndexDataList.areaHigh,
        },
        {
          name: '中风险区域',
          value: this.IndexDataList.areaMid,
        },
        {
          name: '低风险区域',
          value: this.IndexDataList.areaLow,
        },
        {
          name: '水旱灾害区',
          value: this.IndexDataList.areaWater,
        },
        {
          name: '其他',
          value: this.IndexDataList.areaOther,
        },
      ];

      let mapData = [];
      let color = ['#ffffff', '#ffe000', '#ffa800', '#16F2DA', '#F77F76'];
      for (let i = 0; i < trafficWay.length; i++) {
        mapData.push(
          {
            value: trafficWay[i].value,
            name: trafficWay[i].name,
            itemStyle: {
              normal: {
                borderWidth: 10,
                // shadowBlur: 4,
                borderColor: color[i],
                shadowColor: color[i],
              },
            },
            label: {
              color: color[i],
            },
          },
          {
            // 圆环设置间隔 这里的10是间距，背景色为透明
            value: 2,
            itemStyle: {
              normal: {
                color: 'rgba(0, 0, 0, 0)',
              },
            },
          }
        );
      }
      const seriesOption = [
        {
          name: '',
          type: 'pie',
          startAngle: 90,
          radius: [55, 65],
          // hoverAnimation: false,
          center: ['50%', '50%'],
          itemStyle: {
            normal: {
              labelLine: {
                show: false,
              },
              color: 'rgba(217, 217, 217, .5)',
              shadowBlur: 10,
              shadowColor: '#f5f5f5',
            },
          },
          data: [
            {
              value: 100,
            },
          ],
        },
        {
          name: '',
          type: 'pie',
          clockWise: false,
          radius: [75, 85],
          center: ['50%', '50%'], //控制圆位置
          startAngle: -90,
          clockWise: false, //饼图的扇区是否是顺时针排布，默认true
          hoverAnimation: false,
          itemStyle: {
            normal: {
              borderRadius: 0,
              label: {
                show: true,
                position: 'outside',
                // color: '#ddd',
                formatter: function (params) {
                  var percent = 0;
                  var total = 0;
                  for (var i = 0; i < trafficWay.length; i++) {
                    total += trafficWay[i].value;
                  }
                  percent = ((params.value / total) * 100).toFixed(0);
                  if (params.name !== '') {
                    // return params.name + '\n' + percent + '%';
                    return '{name|' + params.name + '}' + '\n{percent|' + percent + '%}';
                  } else {
                    return '';
                  }
                },
                padding: [90, -40],
                rich: {
                  name: {
                    fontSize: 12,
                    padding: [10, 0],
                    align: 'left',
                  },
                  percent: {
                    fontSize: 14,
                    align: 'left',
                    padding: [5, 0],
                  },
                },
              },
              labelLine: {
                length: 30,
                length2: 60,
                show: true,
                color: '#00ffff',
              },
            },
          },
          data: mapData,
        },
      ];
      let option = {
        tooltip: {
          show: false,
          backgroundColor: 'rgba(0,0,0,0.8)', //设置背景图片 rgba格式
          color: '#fff',
          borderWidth: '1', //边框宽度设置1
          borderColor: 'gray', //设置边框颜色
          textStyle: {
            color: '#fff', //设置文字颜色
          },
        },
        // legend: {
        //   icon: 'roundRect',
        //   orient: 'vertical',
        //   data: ['高风险区域', '中风险区域', '低风险区域', '水旱灾害区', '其他'],
        //   left: 20,
        //   top: 20,
        //   textStyle: {
        //     color: '#ff0000',
        //   },
        //   itemGap: 10,
        // },
        toolbox: {
          show: false,
        },
        series: seriesOption,
      };
      myChart.setOption(option);
    },
  }
}
</script>

<style  scoped>
@import "@/assets/css/index.css";
@import "@/assets/css/left.css";
</style>